module.exports = __webpack_public_path__ + "img/card-placeholder-fam.svg";